exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Modal__Content[data-v-727bf1b9]{z-index:3000}.Modal__Title[data-v-727bf1b9]{font-weight:700;font-size:20px}", ""]);
